import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

// El peso se hereda de la celda: 400 en filas normales (tema) y 600 en las no leídas (.not_read)
export const MTTextStyled = styled.div`
  font-size: 13px;
  font-weight: inherit;
  text-align: start;
  color: ${props => (props.color && props.color !== 'black' ? props.color : `${tokens.color.text.primary} !important`)};
`
